import { API_ENDPOINTS } from "../../../Api/apiEndPoints"
import axiosInstance from "../../../Api/axiosInstance"


export const getEmpolyeeFilter = async(param:any)=>{
   let response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_EMPOLYEE_FILTER}`,{params:param});
   let rowData = await response?.data;

   const formatedData = Object.entries(rowData.data ||{}).map(([key,value])=>({  
      id:key,
      label: String(value)
   }))
    
   // console.log('formatedData',formatedData);
   return {formatedData,rowData};
   // console.log('formatedData',formatedData);
   // console.log('rowData',rowData);
}

export const getDarReport = async(param:any )=>{
   const response = await  axiosInstance.get(`${API_ENDPOINTS.Reports.GET_DAR_REPORT}`,{params:param});
   const rowData = response?.data;    
   return{rowData};
}
